/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Fireblocks deposit address info
 */
export interface DepositAddressInfo {
  /**
   * Address.
   */
  address: string;
  /**
   * Legacy address.
   */
  legacyAddress: string;
  /**
   * Deposit vault ID.
   */
  vaultId: number;
}
